export function pttFirstName(displayName?: string): string {
  const name = displayName?.trim();
  if (!name) return 'Someone';
  return name.split(/\s+/)[0] || name;
}

export function pttRadioLabel(displayName?: string): string {
  return `${pttFirstName(displayName)} is on Radio Call`;
}
